var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _path, _path2, _line, _circle, _polyline, _path3, _ellipse, _ellipse2, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtHomeComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1177 1166",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffb3a4;}.cls-2{fill:#fff4de;}.cls-3{fill:#f1b104;}.cls-4{fill:#d6eaf2;}.cls-18,.cls-5{fill:#fff;}.cls-23,.cls-5{stroke:#639ad6;}.cls-18,.cls-19,.cls-23,.cls-5,.cls-6,.cls-7{stroke-miterlimit:10;}.cls-18,.cls-19,.cls-20,.cls-21,.cls-23,.cls-5,.cls-6,.cls-7{stroke-width:3px;}.cls-19,.cls-20,.cls-21,.cls-23,.cls-6,.cls-7{fill:none;}.cls-6{stroke:#fff;}.cls-7{stroke:#41465a;}.cls-8{fill:#252954;}.cls-9{clip-path:url(#clip-path);}.cls-10{fill:#242854;}.cls-11{fill:#ea786c;}.cls-12{fill:#3a193f;}.cls-13{fill:#a1cbe2;}.cls-14{fill:#f9c543;}.cls-15{fill:#db7800;}.cls-16{fill:#f4e8ce;}.cls-17{fill:#ffd473;}.cls-18,.cls-19{stroke:#f1b104;}.cls-20{stroke:#3a1a3f;}.cls-20,.cls-21{stroke-linecap:round;stroke-linejoin:round;}.cls-21{stroke:#e2564b;}.cls-22{fill:#ffcdc5;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M740.1,352.23s-3.23,41.78,13.5,54.59L708.06,406s1.07-46.27,0-53.75Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NOTES"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 947.33,
    y: 223.55,
    width: 42.53,
    height: 42.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 966.31,
    y: 218.31,
    width: 4.57,
    height: 10.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M920.9,223.55v86.39a14.55,14.55,0,0,1-14.55,14.55H831.57v0a14.53,14.53,0,0,0,13.82-14.52V223.55Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 878.55,
    y: 218.31,
    width: 4.57,
    height: 10.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 859.88,
    y1: 244.43,
    x2: 904.6,
    y2: 244.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 859.88,
    y1: 255.52,
    x2: 904.6,
    y2: 255.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 859.88,
    y1: 266.6,
    x2: 904.6,
    y2: 266.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 859.88,
    y1: 277.69,
    x2: 904.6,
    y2: 277.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 859.88,
    y1: 288.78,
    x2: 904.6,
    y2: 288.78
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "CHAIR"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "638.11 781.58 581.75 1055.29 587.14 1055.29 662.55 781.65"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "837.98 775.12 895.45 1055.29 890.23 1055.29 814.89 781.53"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "759.71 781.58 816.06 1055.29 810.67 1055.29 735.26 781.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M899.52,647.15l-34,101.05a51.65,51.65,0,0,1-49,35.18H624a51.66,51.66,0,0,1-49-35.18l-28-83.12a22.36,22.36,0,0,1,21.19-29.49h21.55A20.37,20.37,0,0,0,610,618.05l12.56-89.15a43.14,43.14,0,0,1,42.72-37.13H838.62a43.15,43.15,0,0,1,42.73,49.13l-10.78,76.92A15.6,15.6,0,0,0,886,635.59h5.2A8.76,8.76,0,0,1,899.52,647.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M885,634.51H870.76a44.31,44.31,0,0,0-42.31,30l-24.39,67.76a46.78,46.78,0,0,1-44.32,31.85H582.3"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "WOMAN"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HAIR"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M733.78,264.85c43.81,1,25.92,47.06,50.78,55.13,17.6,5.71,39.74,14.12,39.27,49.43-.39,29.13-2.92,33.19,19.31,45.63,30.46,17,22.24,74.3-39.17,72.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M667,298c1.07-2.92,10-41.52,68.17-34.72,43.52,5.09,26,54.32,46.6,61.27,15.62,5.26,39.63,13.25,37.06,48.47-2.12,29.05-4.89,33,16.56,46.69,29.4,18.84,17.78,75.5-43.4,69.8S639.24,486,635.1,474.14c-3-8.7-28.87-60.19,8.76-82.49,11.32-6.71,32.22-14.86,30-27.9C669.36,337.35,655.78,328.58,667,298Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "NECK"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M740.1,352.23s-3.23,41.78,13.5,54.59L708.06,406s1.07-46.27,0-53.75Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 718.29,
    cy: 363.41,
    rx: 31.25,
    ry: 22.83
  }))), /*#__PURE__*/React.createElement("g", {
    id: "HEAD"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M751.52,336.94s-9.12,39.82-41.94,38.42c-21.82-.93-33.1-38.58-34.69-56.61-1.33-15.05,18.29-26.62,32.66-23.57,17.7,3.76,18.66,33.13,37.26,31.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M698.38,321.31a126.24,126.24,0,0,0-22,7.84,63.18,63.18,0,0,1-2.27-11.4c-1-11,9.21-20.11,20.37-23.06,1.17.38,2.38.8,3.65,1.27C703.9,298.09,694.7,309.13,698.38,321.31Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "HAIR-2",
    "data-name": "HAIR"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M705.28,294.42c6.07,2.24-7.34,14-4.41,27a370.2,370.2,0,0,0-38.07,10.37s-11.49-17.65-2.41-29.68S685.77,287.22,705.28,294.42Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 745.05,
    cy: 327.84,
    r: 11.03
  }), /*#__PURE__*/React.createElement("path", {
    id: "LEFT_HAND",
    "data-name": "LEFT HAND",
    className: "cls-1",
    d: "M652.43,427.49c14.9-7.52,31.16,2.67,23.1,26.36-5.84,17.15-57.95,118.46-63.86,127.26C575.78,601.19,435,578.4,435,578.4s-19.58,8.35-25.26,8.42c-2.49,0-17.64-2.84-17.64-2.84s-.49-1.75,1.84-3.93,18.62.28,12.84-5c-2.57-2.33-16,2.15-22,7.47s-8.55.81-8.55.81,5.93-10.06,8-11.84,15.53-9.16,24.48-10c6.49-.61,22,1.21,30.08,3.52,31.44-6.1,95.64-14.53,137.32-12.06C576.05,553,619.33,444.2,652.43,427.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "TORSO",
    className: "cls-2",
    d: "M751.41,392.09s9.6,17.51,62.3,35.6c0,0-.19,22.66-8.74,52.46-13.53,47.16-31,113.1-30.74,139.07,0,0-56.83,16.37-115.45,0,0,0,.44-78.68-4.55-82.24s-17.88-36.56-13.61-52.93,21.27-59.12,21.27-59.12,34.79-10.41,37.77-31.06A205.41,205.41,0,0,0,751.41,392.09Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "LEGS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LEFT_LEG",
    "data-name": "LEFT LEG"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FOOT"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M456.27,921c-9.1,33.83-38.57,66.21-36.75,73.48s13.17,16.18,10.2,27.64c-2.08,8-18.74,4.12-31.65,10.55s-8.68,13.11-29.42,13.83-38.21,0-38.21,0,.36-8,9.82-9.82,40.34-20,49.8-56.75c8.76-34,11.64-58.93,11.64-58.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M456.27,921c-2.69,10-7.38,19.84-12.1,29-21.08-1.56-35.62-6.71-45.16-11.38,1.93-11,2.69-17.57,2.69-17.57Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "PANT",
    className: "cls-13",
    d: "M659.2,609.63l-14.86,14.92c-5.46,1.45-153.51,48.38-173.52,75.66S385.7,925.73,385.7,925.73s27.64,19.41,94.59,12.1c0,0,38.18-79.74,43.64-189.24,0,0,169.15,11.65,193.89-29.1s3.67-102.22,3.67-102.22S677.94,615.34,659.2,609.63Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SLIPPER"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 314.89,
    y: 1046.85,
    width: 117.5,
    height: 10.23,
    rx: 4.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M384.73,1046.85s-13.58-15.87-16.13-31.53c-.9-5.54-18.12,2.49-27.8,6.47-26.31,10.81-20.8,25.06-20.8,25.06Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "RIGHT_LEG",
    "data-name": "RIGHT LEG"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FOOT-2",
    "data-name": "FOOT"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M580.17,922.52c6.51,14.22,25.58,61.54,26,77.42.68,23.38-40.69,43.35-43.49,45.68-4.65,3.87.85,6.86.85,6.86s77.35-8.8,86-12.8-11.27-26.08-13.28-42.32.88-61.34-2.69-81.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M635.51,945.64c-11.81,3.87-27.24,8.11-42,9.68-5.11-13.69-10.46-26.5-13.35-32.8l53.45-6.59C634.94,923.33,635.38,934.14,635.51,945.64Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "PANT-2",
    "data-name": "PANT",
    className: "cls-13",
    d: "M774.32,609.63s47.9,84.76,12.62,126.94C748.85,782.12,590.15,765,590.15,765s51.28,55.63,58.92,175.31c0,0-52.43,9.83-84.42,1.46,0,0-46.06-154-49.82-197.14C510.11,690.39,685.08,654,685.08,654l7.07-39S728.19,620.13,774.32,609.63Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SLIPPER-2",
    "data-name": "SLIPPER"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 543.76,
    y: 1046.58,
    width: 117.5,
    height: 10.23,
    rx: 4.87,
    transform: "translate(-124.13 81.61) rotate(-7.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M612.89,1045.26s-10-24-34.34-21-29.9,28.93-29.9,28.93Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "RIGHT_HAND",
    "data-name": "RIGHT HAND"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M853.8,591.24c-27.29,17.31-160-36.57-160-36.57s-8,11.51-16.83,11.51-17-3.44-21.6.12-9.4,9.34-12.92,9.85A25.18,25.18,0,0,1,629.88,575s3-5.34,6.15-10.48c-2.81,1.89-6.63,6.1-8.76,7.75a4.89,4.89,0,0,1-6,.23s6.16-8.53,8.54-10.79,9.14-5.19,13.42-6.76c4.7-1.82,31.89-12.44,45.31-14,14.24-1.66,130.21,9.73,130.21,9.73s-26.41-65.8-28.12-82.85c-2.52-25.15,8.17-40.42,21-40.44C834.47,427.3,876.43,576.89,853.8,591.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M634.16,576.06a.48.48,0,0,1-.28-.08.52.52,0,0,1-.16-.72c.92-1.44,9.07-14.15,11.95-15.58,5-2.46,11.51-5.71,11.51-5.71l.47.94-11.51,5.71c-2.22,1.1-9.08,11.35-11.54,15.2A.51.51,0,0,1,634.16,576.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M639.88,576.06a.52.52,0,0,1-.43-.81c.32-.48,7.95-11.62,10.87-13.06,5-2.47,11.51-5.71,11.51-5.71l.47.93s-6.52,3.25-11.51,5.71c-2.23,1.1-8.32,9.55-10.48,12.72A.53.53,0,0,1,639.88,576.06Z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "TABLE"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 89.29,
    y: 595.72,
    width: 1011.89,
    height: 21.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 947.14,
    y: 982.06,
    width: 126,
    height: 15.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 964.49,
    y: 618.13,
    width: 91.13,
    height: 20.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1090.89,1057.07h0a9.26,9.26,0,0,1-9.11-7.58l-69.63-378.84a2.13,2.13,0,0,0-4.19,0l-69.64,378.84a9.25,9.25,0,0,1-9.11,7.58h0a9.26,9.26,0,0,1-9.11-10.93l75.1-408.56h29.7l75.1,408.56A9.25,9.25,0,0,1,1090.89,1057.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 117.51,
    y: 982.06,
    width: 126,
    height: 15.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 134.85,
    y: 618.13,
    width: 91.13,
    height: 20.16
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M261.26,1057.07h0a9.26,9.26,0,0,1-9.11-7.58L182.51,670.66a2.13,2.13,0,0,0-4.19,0l-69.63,378.83a9.26,9.26,0,0,1-9.11,7.58h0a9.25,9.25,0,0,1-9.11-10.93l75.09-408.56h29.71l75.1,408.56A9.26,9.26,0,0,1,261.26,1057.07Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "MESSAGE_ICON",
    "data-name": "MESSAGE ICON"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M370.71,414.26c5.32,0,9-5.18,9-10.63V373.11A10.72,10.72,0,0,0,369,362.38H299.51a10.72,10.72,0,0,0-10.72,10.73v30.52a10.72,10.72,0,0,0,10.72,10.72h40.73c10,0,15.34,16,15.34,16S359,414.26,370.71,414.26Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 314.38,
    cy: 388.1,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 334.24,
    cy: 388.36,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-14",
    cx: 354.1,
    cy: 388.36,
    r: 4
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "LAPTOP"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M506.86,451.9H344.25a11.13,11.13,0,0,0-10.45,15l41,111.4H565.22L522.82,463A17,17,0,0,0,506.86,451.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M503.66,457.55H345.1a10.85,10.85,0,0,0-10.18,14.6l40,108.63H560.57L519.23,468.41A16.6,16.6,0,0,0,503.66,457.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M374.43,578.27H686.35a15.94,15.94,0,0,1,15.94,15.94v.43a0,0,0,0,1,0,0H390.37a15.94,15.94,0,0,1-15.94-15.94v-.43A0,0,0,0,1,374.43,578.27Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 442.37,
    cy: 519.16,
    rx: 15.76,
    ry: 19.45,
    transform: "translate(-239.45 500.53) rotate(-48)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 592.19,
    y: 584.13,
    width: 13.29,
    height: 4.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 617.58,
    y: 584.13,
    width: 13.29,
    height: 4.77
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "CUP"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M948.67,549.85h-5.14V539.44H896.62v47.38a8.89,8.89,0,0,0,8.9,8.9h29.11a8.9,8.9,0,0,0,8.9-8.9V570.67h5.14a10.41,10.41,0,1,0,0-20.82Zm3.66,14.29a5.46,5.46,0,0,1-3.88,1.6h-4.92v-11h4.92a5.48,5.48,0,0,1,3.88,9.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M923.65,535c-2.47-2.53-15.41-11-12.52-23.19s21.21-9.55,20.65-23.17c-.48-11.55-10.6-6.92-12.82-2.71,0,0,1.34-15.24,15.26-10.15,23.5,8.59-3.78,33-11.58,39.75C915.48,521.74,923.65,535,923.65,535Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M940.08,502.33s-3,10.29-15.21,15.35C924.87,517.68,943.61,517.68,940.08,502.33Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "LAMP"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1075.25,595.72s35.16-192.63-140.94-219.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1075.94,594.65H982.2c6.54-15.17,25-26.11,46.87-26.11S1069.4,579.48,1075.94,594.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1075.94,594.65h-11.8c-6.21-14.39-23.77-24.77-44.47-24.77-1.46,0-2.9,0-4.32.16a63.11,63.11,0,0,1,13.72-1.5C1050.88,568.54,1069.4,579.48,1075.94,594.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M935.82,378c-.85,3.81-3.85,6.79-8.11,8.6-4.88,2.08-11.42,2.63-18.22,1.12S897,383,893.43,379c-3.1-3.44-4.57-7.41-3.73-11.22,1.81-8.18,13.6-12.53,26.34-9.72S937.63,369.8,935.82,378Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M935.82,378c-.79,3.57-3.49,6.42-7.35,8.26a10.28,10.28,0,0,0,3.63-5.68c1.69-7.64-6.57-15.95-18.44-18.58-11.2-2.47-21.62,1-24.19,7.8a10.2,10.2,0,0,1,.23-2c1.81-8.19,13.6-12.54,26.34-9.73S937.63,369.81,935.82,378Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M925.13,384.69a27.63,27.63,0,0,1-28.56-6.32c-1.65-3.6,8.09-4.86,15.68-3.18S928.27,382.79,925.13,384.69Z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "SHELF"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SHADOW",
    className: "cls-2",
    d: "M239.07,296.53H572.4v30.52L239,298.88C238.12,298.79,238.18,296.53,239.07,296.53Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "BOOKS"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 517.29,
    y: 145.58,
    width: 24.32,
    height: 125.15,
    rx: 5.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 488.99,
    y: 156.17,
    width: 26.8,
    height: 117.04,
    rx: 5.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 475.09,
    y: 127.75,
    width: 13.9,
    height: 145.46,
    rx: 4.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 451.77,
    y: 164.65,
    width: 22.32,
    height: 107.08,
    rx: 5.14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M410.26,273.21H390.78l48.73-130.57a2.66,2.66,0,0,1,2.48-1.73h13.82a2.69,2.69,0,0,1,2.48,3.64Z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "SHELF-2",
    "data-name": "SHELF",
    className: "cls-18",
    x: 239.8,
    y: 273.21,
    width: 331.65,
    height: 21.88
  }), /*#__PURE__*/React.createElement("g", {
    id: "PLANT"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M273.32,224.7H357a0,0,0,0,1,0,0v9.19a39.33,39.33,0,0,1-39.33,39.33h-5.06a39.33,39.33,0,0,1-39.33-39.33V224.7a0,0,0,0,1,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M348.63,224.7h-62s-18.14,14.79-28.49,2.66c-7.5-8.78,28.38-9.17,28.38-9.17l1.08-.38s-15.39-32.32-.84-37.71c10-3.73,12.48,23.65,13,32.54,5.29-2.21,15.61-5.4,16.5,3,0,0,1.15-34.59,15.64-31.29,12.05,2.75-5.82,35.26-5.82,35.26l1.25.76s33.11-24.18,41.23-18.56C374.7,206.06,348.63,224.7,348.63,224.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M296.12,224.7s.64-29.82,11.87-29-4.42,29-4.42,29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M296.12,224.7s-11.26-28.14-26.52-20.93c-14.91,7,17.16,20.93,17.16,20.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M319.26,224.7s10.11-25.35,26.14-22.94-19.79,22.94-19.79,22.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M335.75,224.7s31.36-15.79,37-6.27S335.75,224.7,335.75,224.7Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M706.47,358.91s8.26.94,14.88-8.93"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M739.34,330.59s0-9.12,8-9"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 741.19,
    y1: 325.66,
    x2: 746.52,
    y2: 328.15
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-22",
    cx: 753.6,
    cy: 335.97,
    r: 4.05
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-21",
    points: "701.02 331.92 701.02 347.55 705.19 349.24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M708.06,318.44s4.57-3.54,12.46,0"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 715.09,
    cy: 329.63,
    rx: 2.75,
    ry: 3.56,
    transform: "translate(-46.17 128.41) rotate(-9.94)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 689.82,
    cy: 336,
    rx: 2.75,
    ry: 3.56,
    transform: "translate(-58.63 166.99) rotate(-13.24)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "PANT-3",
    "data-name": "PANT",
    className: "cls-23",
    d: "M564.65,941.76s-46.06-154-49.82-197.14C510.11,690.39,685.08,654,685.08,654"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtHomeComputer);
export default __webpack_public_path__ + "static/media/at_home_computer.e2fb5e9e91e8a05396f7f56b4daa160e.svg";
export { ForwardRef as ReactComponent };